/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  default_large_user_icon,
  default_user_icon,
  rating_icon,
} from '../../Shared/Constant/Icons/AllIcons';
import Image from 'next/image';
import Rating from './rating';
import {
  changeDateFormat,
  getThumbnailImage,
} from '../../Shared/Constant/Constant';
import ShowMoreText from 'react-show-more-text';
import tradly from 'tradly';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '../../../store/feature/authSlice';
import axios from 'axios';
import {
  getListingReviews,
  listingDetails,
} from '../../../store/feature/listingSlice';
import { useRouter } from 'next/dist/client/router';
import { Listing_text } from '../../../constant/Translation/Listing';
import { check_login } from '../../../constant/check_auth';

const ReviewBox2 = ({ rating_data, reviews, review_page }) => {
  const { auth_key, login } = useSelector(authSelector);
  const dispatch = useDispatch();
  const router = useRouter();

  const helpful_review = (id, status) => {
    if (check_login(router)) {
      axios
        .post('/api/review/like', {
          data: {
            review: {
              status: status == 0 ? 1 : 0,
            },
          },
          id: id,
        })
        .then((res) => {
          dispatch(
            listingDetails({
              ...router?.query,
            })
          );
          dispatch(
            getListingReviews({
              authKey: auth_key,
              params: {
                type: 'listings',
                id: router?.query?.listing_id
                  ? router?.query?.listing_id
                  : router?.query.id.split('-')[0],
                page: review_page,
                per_page: 30,
              },
            })
          );
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const [show_moe_review, setShow_more_review] = useState(false);

  return (
    <div className=" bg-white rounded-card   w-full min-h-min ">
      {/* <p className="text-black text-base  font-bold ">
        {' '}
        Review {`(${rating_data?.review_count})`}
      </p> */}
      <div className="mt-4">
        {reviews.map((item, index, array) => {
          return (
            <div
              key={index}
              className={[
                'min-h-min p-4  rounded-card    my-3',
                array.length > 1 && !show_moe_review && index + 1 !== 1
                  ? 'hidden'
                  : 'block',
              ].join(' ')}
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full overflow-hidden">
                  {item.user.profile_pic ? (
                    <img
                      src={getThumbnailImage(item.user.profile_pic)}
                      alt="image"
                      className=" w-full h-full object-cover"
                    />
                  ) : (
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 24 24"
                      fill="#6e686e"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 2C10.0605 2.00369 8.16393 2.57131 6.54128 3.63374C4.91862 4.69617 3.63994 6.20754 2.86099 7.98377C2.08204 9.76 1.83643 11.7244 2.15408 13.6378C2.47173 15.5511 3.33893 17.3308 4.65005 18.76C5.58647 19.775 6.72299 20.5851 7.98799 21.1392C9.25298 21.6933 10.619 21.9793 12 21.9793C13.3811 21.9793 14.7471 21.6933 16.0121 21.1392C17.2771 20.5851 18.4136 19.775 19.35 18.76C20.6612 17.3308 21.5284 15.5511 21.846 13.6378C22.1637 11.7244 21.9181 9.76 21.1391 7.98377C20.3602 6.20754 19.0815 4.69617 17.4588 3.63374C15.8362 2.57131 13.9396 2.00369 12 2ZM12 20C9.92851 19.9969 7.93896 19.1903 6.45005 17.75C6.90209 16.6495 7.67108 15.7083 8.6593 15.0459C9.64752 14.3835 10.8104 14.0298 12 14.0298C13.1897 14.0298 14.3526 14.3835 15.3408 15.0459C16.329 15.7083 17.098 16.6495 17.55 17.75C16.0611 19.1903 14.0716 19.9969 12 20ZM10 10C10 9.60444 10.1173 9.21776 10.3371 8.88886C10.5569 8.55996 10.8692 8.30362 11.2347 8.15224C11.6001 8.00087 12.0023 7.96126 12.3902 8.03843C12.7782 8.1156 13.1346 8.30608 13.4143 8.58579C13.694 8.86549 13.8844 9.22186 13.9616 9.60982C14.0388 9.99778 13.9992 10.3999 13.8478 10.7654C13.6964 11.1308 13.4401 11.4432 13.1112 11.6629C12.7823 11.8827 12.3956 12 12 12C11.4696 12 10.9609 11.7893 10.5858 11.4142C10.2108 11.0391 10 10.5304 10 10ZM18.91 16C18.0166 14.4718 16.6415 13.283 15 12.62C15.5092 12.0427 15.841 11.3307 15.9555 10.5694C16.0701 9.80822 15.9625 9.03011 15.6458 8.3285C15.3291 7.62688 14.8166 7.03156 14.17 6.61397C13.5233 6.19637 12.7698 5.97425 12 5.97425C11.2303 5.97425 10.4768 6.19637 9.83014 6.61397C9.18346 7.03156 8.67102 7.62688 8.3543 8.3285C8.03758 9.03011 7.93004 9.80822 8.04458 10.5694C8.15912 11.3307 8.49088 12.0427 9.00005 12.62C7.35865 13.283 5.98352 14.4718 5.09005 16C4.37799 14.7871 4.00177 13.4065 4.00005 12C4.00005 9.87827 4.8429 7.84344 6.34319 6.34315C7.84349 4.84285 9.87832 4 12 4C14.1218 4 16.1566 4.84285 17.6569 6.34315C19.1572 7.84344 20 9.87827 20 12C19.9983 13.4065 19.6221 14.7871 18.91 16Z" />
                    </svg>
                  )}
                </div>
                <p className="description-paragraph ">{item.user.first_name}</p>
                <p className="description-caption ">
                  {changeDateFormat(item.created_at, 'MMM DD,YYYY')}
                </p>
              </div>
              <div className=" px-10 my-2 flex items-center gap-3">
                <Rating rating_value={Number(item.rating)} />
              </div>
              <div className="px-10">
                <ShowMoreText
                  /* Default options */
                  lines={3}
                  more="View More"
                  less="View Less"
                  anchorClass="text-lg text-primary  "
                  expanded={false}
                  truncatedEndingComponent={'... '}
                >
                  {item.content}
                </ShowMoreText>
              </div>
              <div className="px-10 mt-4 flex items-center justify-start flex-wrap gap-3  ">
                {item?.images.map((img, index) => {
                  return (
                    <div
                      className="w-24 h-24 rounded-image overflow-hidden"
                      key={index}
                    >
                      <img
                        src={img}
                        alt="image"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  );
                })}
              </div>
              <div className="px-10 mt-4   flex items-center justify-start gap-3">
                <button
                  onClick={() => helpful_review(item.id, item.like_status)}
                  className="flex-none p-3 rounded-full  transition duration-400  hover:bg-[#22222213]"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 13 13"
                    fill={
                      item.like_status == 0 ? '#000' : 'var( --primary_color)'
                    }
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 12.7612H2.36364V5.10458H0V12.7612ZM13 5.74244C13 5.04059 12.4682 4.46634 11.8182 4.46634H8.08956L8.65093 1.55046L8.66865 1.34628C8.66865 1.08468 8.5682 0.842225 8.40865 0.669952L7.78229 0L3.89411 4.20474C3.67547 4.43444 3.54547 4.75347 3.54547 5.10439V11.4849C3.54547 12.1867 4.07729 12.761 4.72729 12.761H10.0455C10.5359 12.761 10.9555 12.442 11.1327 11.9826L12.9173 7.48432C12.9705 7.33757 13 7.18443 13 7.01854V5.79987L12.9941 5.79349L13 5.74244Z"
                    />
                  </svg>
                </button>
                <span className="description-caption ">{item.likes}</span>
              </div>
            </div>
          );
        })}
      </div>
      {reviews.length > 1 && (
        <div
          className={[
            ' w-full flex justify-center mt-6 mb-3',
            show_moe_review && 'hidden',
          ].join(' ')}
        >
          <button
            className=" w-4/6 text-center py-3 border border-primary text-primary text-lg rounded-button"
            onClick={() => setShow_more_review(true)}
          >
            {Listing_text.product.read_all_reviews}
          </button>
        </div>
      )}
    </div>
  );
};

export default ReviewBox2;
